firebird.controller('loadingCtrl', [
    '$rootScope',
    '$timeout',
    'cfpLoadingBar',
    'analyticsWrapperService',
    'meetingService',
    'supportLinkService',
    'localizationService',
    '$window',
    function (
        $rootScope,
        $timeout,
        cfpLoadingBar,
        analyticsWrapperService,
        meetingService,
        supportLinkService,
        localizationService,
        $window
    ) {
        var self = this;

        self.show = false;
        self.message = localizationService.translate('LOBBY_PAGE.MEETING_NOW_LOADING');
        self.altMessage = '';
        self.submessage = '';
        self.isLastMessage = false;
        self.loadingCompleted = false;
        self.getAppLogoURL = meetingService.getAppLogoURL;
        self.supportLink = '';
        self.onSupportLinkClick = onSupportLinkClick;

        $rootScope.$on('$stateChangeStart', onStateChangeStart);

        init();

        ////////////////////////

        function init() {
            cfpLoadingBar.start();
            //jquery hack for hiding the loading spinner during XHR requests
            $window.$('body > #loading-bar-spinner').hide();

            //The server loads pretty quickly...
            //It doesn't look too good to see this message flash for half
            //a second before the meeting loads (can't even read the message)
            //So, this will show after 3 seconds, in case the server does
            //happen to be taking a while.
            $timeout(function () {
                self.show = true;
            }, 3000);

            //Main idea: fade one message out while fading the other message in
            $timeout(function () {
                self.altMessage = localizationService.translate('LOBBY_PAGE.HOLD_ON_GEARS_STILL_GRINDING');
                self.message = '';

                // Without this statement event fires even though the message never appears
                if (!self.loadingCompleted) {
                    analyticsWrapperService.eventTrack('Meeting - Loading - Still Grinding');
                }
            }, 15000);

            $timeout(function () {
                self.message = localizationService.translate('LOBBY_PAGE.THIS_MIGHT_TAKE_A_MINUTE');
                self.altMessage = '';
            }, 30000);

            $timeout(function () {
                self.altMessage = localizationService.translate('LOBBY_PAGE.STILL_ATTEMPTING_TO_LOAD_MEETING');
                self.supportLink = supportLinkService.getSupportLink('generic');

                self.message = '';
                self.isLastMessage = true;
            }, 60000);
        }

        function onSupportLinkClick() {
            meetingService.openExternalLink(self.supportLink);
        }

        function onStateChangeStart(event, toState, toParams, fromState, fromParams) {
            if (fromState.name === 'loading') {
                cfpLoadingBar.complete();
                self.loadingCompleted = true;
            }
        }
    }
]);
